import React from 'react'
import { Row, Col, Card } from 'react-bootstrap'
import Footer from '../partials/Footer'
import Header from '../partials/Header'
import Navigationbar from '../partials/Navigationbar'

const Home = () => {
  return (
    <div className='content'>
      <Navigationbar />
      <Header />
       <main className='containe'>
        <div className='fs-5 mb-5 pt-3'>
            <div className='about container'   id='about'>
                <h1 className='text-center fw-bold text-capitalize'><span className='active'>Who</span> are we?</h1>
            <Row xs={1} md={2}  className='pt-4 mb-5'>
              <Col>
                <div className=''>
                <p>
                  With innovative and insightful Technology, we strive to enhance our client’s experience every day. Founded in 2021, our incredible team of programmers and designers have worked tirelessly to bring IT_LOGISTS to the forefront of the industry.<br />
                  We will continue to work relentlessly to become the technological standard, providing solutions for companies of all sizes.
                </p>
                <p>
                  At IT_LOGISTS, our comprehensive technology solution helps industries, leading companies and even individuals achieve greater success.
                  Our platform has a wide range of features that were created with an aim to help your business differently.
                  In order to empower our users to do better, IT_LOGISTS is continually building upon its technology so stay in touch to learn more about us.
                </p>
              </div>
              </Col>
              <Col>
                <div className='p-3'>
                  <img className='img img-fluid' src='/images/profile2.svg' alt='...' />
                </div>
              </Col>
            </Row>
            </div>   
          <div className='reasons-section fs-5 mb-5 pt-3 container' id='why'>
            <h1 className='fw-bold text-capitalize text-center mb-4'>
              Why <span className='active'>Choose</span> us
            </h1>
            <Row xs={1} sm={2} md={4} lg={4} className="gx-3 gy-3 reason-cards">
              <Col>
                <Card className='border-0 shadow h-100'>
                  <Card.Body>
                    <img className='img img-fluid w-25' src='/images/fast3.svg' alt='...' />
                    <h4 className=''>Fast & Reliable Systems</h4>
                    <p> We build systems that run with ease across multiple platforms, you are guaranteed 99.9% uptime.</p>
                  </Card.Body>
                </Card>
              </Col>
              <Col>
                <Card className='border-0 shadow  h-100'>
                    <Card.Body>
                      <img className='img img-fluid w-25' src='/images/tune.svg' alt='...' />
                      <h4 className=''>Customisable Systems</h4>
                      <p>We build with the future in mind. Our Systems can be scaled as your business needs increases.</p>
                    </Card.Body>
                </Card>
              </Col>
              <Col>
                <Card className='border-0 shadow h-100'>
                  <Card.Body>
                    <img className='img img-fluid w-25' src='/images/clean.svg' alt='...' />
                    <h4 className=''>Unique Systems</h4>
                    <p>With us you get a specific system that is tailored just for your business needs.</p>
                  </Card.Body>
                </Card>
              </Col>
              <Col>
                <Card className='border-0 shadow  h-100'>
                  <Card.Body>
                    <img className='img img-fluid w-25' src='/images/transparent.svg' alt='...' />
                    <h4 className=''>Transparency</h4>
                    <p>We prioritise our clients to ensure they receive high-end products at rightful costs. </p>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </div>
          <div className='contact' id='contacts'>
            <div className='container fs-5 mb-5 pt-3'>
              <h1 className='fw-bold text-capitalize text-center'><span className='active'>Contact</span> us</h1>
              <p className='text-center text-muted'>
                Get in touch with us to learn more
              </p>
              <div className='d-flex justify-content-evenly align-items-center flex-column'>
                <div className='contacts mb-3'>
                  <i className="bi bi-telephone"></i>
                  <a href="tel:+254712469566" className='text-dark lead'> +254712469566</a>
                </div>
                <div className='contacts mb-3'>
                  <i className="bi bi-envelope"></i>
                  <a href="mailto:itlogist@gmail.com" className='text-dark lead'> itlogist@gmail.com</a>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default Home